import { useMediaQuery } from '@material-ui/core';

export default function useFullscreenPopup() {

    const maxWidth = useMediaQuery('(max-width:350px)');

    const maxHeight = useMediaQuery('(max-height:300px)');

    return maxWidth || maxHeight;
}